module.exports = __webpack_public_path__ + "media/images/favicon/secondary/apple-icon-60x60-ac088e4b8a2a0fae2fdbf1d7d366adc7.png";